module.exports = __webpack_public_path__ + "img/philosopher.92032c70.png";